import type { BrandProfileField, BrandProfileFieldApi, BrandProfileFieldName } from './types';

export function mapBrandProfileFieldFromApi(raw: BrandProfileFieldApi): BrandProfileField {
    return {
        id: raw.id,
        fieldName: raw.field_name as BrandProfileFieldName,
        weightage: raw.weightage,
        isRequired: raw.is_required,
        inputType: raw.input_type,
        currentValue: raw.current_value,
        lastModifiedByUserId: raw.last_modified_by_user_id,
        allowedValues: raw.allowed_values,
        createdTimestamp: raw.created_timestamp,
        lastModifiedTimestamp: raw.last_modified_timestamp,
    };
}

export function mapBrandProfileFromApi(rows: BrandProfileFieldApi[]): BrandProfileField[] {
    return rows.map(mapBrandProfileFieldFromApi);
}
